import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { WORKFLOW_SHARE_ROUTE_PREFIX } from "../../../data/constants";

/** Copy link builds `${origin}${WORKFLOW_SHARE_LINK_PREFIX}${refNo}`. */
export const WORKFLOW_SHARE_LINK_PREFIX = WORKFLOW_SHARE_ROUTE_PREFIX;

/**
 * Decision 6.5: `/wf/{RefNo}` opens that case on the Run screen. It only redirects — to
 * `/workflow/run?refNo=`, which MenuGuard guards like any opened case and which resolves the RefNo
 * through the same read — so the link needs sign-in and case access, and is never public.
 */
const WorkflowShareLink: React.FC = () => {
  const { refNo = "" } = useParams<{ refNo: string }>();
  const query = new URLSearchParams({ refNo: refNo.trim(), source: "instances" });
  return <Navigate to={`/workflow/run?${query.toString()}`} replace />;
};

export default WorkflowShareLink;
